module.exports = __webpack_public_path__ + "play_archivist_logo_white.png?7769820d9c42b41bbbc362c94fa9a18e";


//////////////////
// WEBPACK FOOTER
// ./src/img/play_archivist_logo_white.png
// module id = 133
// module chunks = 0